import { motion } from "framer-motion";
import { EASE } from "@/lib/brand";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, inView = false, className = "" }) => {
  const anim = inView ? { whileInView: "show", viewport: { once: true, amount: 0.1 } } : { animate: "show" };
  const variants = { hidden: { y: "110%" }, show: { y: "0%", transition: { duration: 1.1, ease: EASE, delay } } };
  return (
    <motion.span initial="hidden" {...anim} className={`block overflow-hidden pb-[0.06em] ${className}`}>
      <motion.span className="block" variants={variants}>
        {children}
      </motion.span>
    </motion.span>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.28em] text-[var(--mth-blue-soft)] ${className}`}>{children}</p>
);
